const cueSet3 = [
    {
          "duration": 4.411762500000002,
          "durationTicks": 115200,
          "midi": 50,
          "name": "D3",
          "ticks": 491520,
          "time": 18.823520000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2941174999999987,
          "durationTicks": 7680,
          "midi": 48,
          "name": "C3",
          "ticks": 606720,
          "time": 23.235282500000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 614400,
          "time": 23.529400000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 618240,
          "time": 23.676458750000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 625920,
          "time": 23.970576250000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 629760,
          "time": 24.117635000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 637440,
          "time": 24.411752500000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.1470587500000029,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 641280,
          "time": 24.55881125,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 648960,
          "time": 24.852928750000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 652800,
          "time": 24.999987500000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 660480,
          "time": 25.294105000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937500000323,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 664320,
          "time": 25.44116375,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 668160,
          "time": 25.588222500000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 675840,
          "time": 25.882340000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 679680,
          "time": 26.029398750000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 687360,
          "time": 26.323516250000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 691200,
          "time": 26.470575000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 698880,
          "time": 26.764692500000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 702720,
          "time": 26.911751250000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 710400,
          "time": 27.205868750000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 714240,
          "time": 27.352927500000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 721920,
          "time": 27.647045000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2941174999999987,
          "durationTicks": 7680,
          "midi": 45,
          "name": "A2",
          "ticks": 729600,
          "time": 27.941162500000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 4.411762500000002,
          "durationTicks": 115200,
          "midi": 47,
          "name": "B2",
          "ticks": 737280,
          "time": 28.235280000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2941174999999987,
          "durationTicks": 7680,
          "midi": 45,
          "name": "A2",
          "ticks": 852480,
          "time": 32.647042500000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 860160,
          "time": 32.94116,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 864000,
          "time": 33.08821875,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 871680,
          "time": 33.38233625,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 875520,
          "time": 33.529395,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 883200,
          "time": 33.82351250000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 887040,
          "time": 33.970571250000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 894720,
          "time": 34.264688750000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 898560,
          "time": 34.411747500000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 906240,
          "time": 34.705865,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 910080,
          "time": 34.85292375,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 913920,
          "time": 34.9999825,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937500000678,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 921600,
          "time": 35.2941,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 925440,
          "time": 35.44115875000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 933120,
          "time": 35.735276250000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 936960,
          "time": 35.882335000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 944640,
          "time": 36.1764525,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 948480,
          "time": 36.32351125,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 956160,
          "time": 36.61762875,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705875000000646,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 960000,
          "time": 36.7646875,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 967680,
          "time": 37.05880500000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2941174999999987,
          "durationTicks": 7680,
          "midi": 48,
          "name": "C3",
          "ticks": 975360,
          "time": 37.352922500000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 4.411762500000002,
          "durationTicks": 115200,
          "midi": 50,
          "name": "D3",
          "ticks": 983040,
          "time": 37.647040000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2941174999999987,
          "durationTicks": 7680,
          "midi": 48,
          "name": "C3",
          "ticks": 1098240,
          "time": 42.058802500000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 1105920,
          "time": 42.352920000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 1109760,
          "time": 42.499978750000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 1117440,
          "time": 42.79409625,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 1121280,
          "time": 42.941155,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 1128960,
          "time": 43.23527250000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 1132800,
          "time": 43.38233125000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 1140480,
          "time": 43.676448750000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 1144320,
          "time": 43.823507500000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 1152000,
          "time": 44.117625000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 1155840,
          "time": 44.26468375,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 1159680,
          "time": 44.4117425,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937500000678,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 1167360,
          "time": 44.70586,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 1171200,
          "time": 44.85291875000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 1178880,
          "time": 45.147036250000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 1182720,
          "time": 45.294095000000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 1190400,
          "time": 45.588212500000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 1194240,
          "time": 45.735271250000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 50,
          "name": "D3",
          "ticks": 1201920,
          "time": 46.02938875,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705875000000646,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 1205760,
          "time": 46.1764475,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 50,
          "name": "D3",
          "ticks": 1213440,
          "time": 46.47056500000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2941174999999987,
          "durationTicks": 7680,
          "midi": 45,
          "name": "A2",
          "ticks": 1221120,
          "time": 46.764682500000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 4.411762500000002,
          "durationTicks": 115200,
          "midi": 47,
          "name": "B2",
          "ticks": 1228800,
          "time": 47.058800000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2941174999999987,
          "durationTicks": 7680,
          "midi": 45,
          "name": "A2",
          "ticks": 1344000,
          "time": 51.47056250000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 1351680,
          "time": 51.764680000000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 1355520,
          "time": 51.911738750000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 1363200,
          "time": 52.205856250000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 1367040,
          "time": 52.352915,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 1374720,
          "time": 52.64703250000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 1378560,
          "time": 52.79409125000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 1386240,
          "time": 53.08820875000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 1390080,
          "time": 53.235267500000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 1397760,
          "time": 53.529385000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 1401600,
          "time": 53.676443750000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 1405440,
          "time": 53.823502500000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937500000678,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 1413120,
          "time": 54.11762,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 1416960,
          "time": 54.26467875000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 1424640,
          "time": 54.55879625000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 1428480,
          "time": 54.70585500000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 1436160,
          "time": 54.999972500000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 1440000,
          "time": 55.147031250000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07352937499999967,
          "durationTicks": 1920,
          "midi": 47,
          "name": "B2",
          "ticks": 1447680,
          "time": 55.44114875,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705875000000646,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 1451520,
          "time": 55.5882075,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.14705874999999935,
          "durationTicks": 3840,
          "midi": 47,
          "name": "B2",
          "ticks": 1459200,
          "time": 55.88232500000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2941174999999987,
          "durationTicks": 7680,
          "midi": 48,
          "name": "C3",
          "ticks": 1466880,
          "time": 56.17644250000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 4.7058800000000005,
          "durationTicks": 122880,
          "midi": 50,
          "name": "D3",
          "ticks": 1474560,
          "time": 56.470560000000006,
          "velocity": 0.7874015748031497
        }
];

export default cueSet3;
